import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";

import "bootstrap/dist/js/bootstrap.js";
import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "flag-icon-css/css/flag-icon.min.css";

import "@progress/kendo-theme-material/dist/all.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./index.scss";

import App from "./App";
import "./i18n";
import store from "./redux/configureStore";
import "@progress/kendo-licensing";

// MSAL imports
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { fetchAzureAdConfig, getMsalConfig } from "./config/msalConfig";
import { AuthProvider } from "./contexts/AuthContext";

const LoadingMarkup = () => {
  return (
    <div className='py-4 text-center'>
      <h3>Loading..</h3>
    </div>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Initialize MSAL and render app
(async () => {
  try {
    console.log("[APP INIT] Fetching Azure AD configuration from backend...");

    // Step 1: Fetch Azure AD configuration from backend
    await fetchAzureAdConfig();

    console.log("[APP INIT] Creating MSAL instance...");

    // Step 2: Create MSAL instance with fetched config
    const msalConfig = getMsalConfig();
    const msalInstance = new PublicClientApplication(msalConfig);

    console.log("[APP INIT] Initializing MSAL...");

    // Step 3: Initialize MSAL (required before rendering)
    await msalInstance.initialize();

    console.log("[APP INIT] MSAL initialized successfully, rendering app...");

    root.render(
      <Suspense fallback={<LoadingMarkup />}>
        <MsalProvider instance={msalInstance}>
          <AuthProvider>
            <Provider store={store}>
              <App />
            </Provider>
          </AuthProvider>
        </MsalProvider>
      </Suspense>
    );
  } catch (error) {
    console.error("[APP INIT] Failed to initialize:", error);
    // Render error state
    root.render(
      <div className='py-4 text-center'>
        <h3>Failed to initialize authentication</h3>
        <p>
          {error instanceof Error ? error.message : "Unknown error occurred"}
        </p>
        <p>Please refresh the page to try again.</p>
      </div>
    );
  }
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
